<script>
import moment from "@/utils/moment";
import Modal from "@/components/_Shared/Modal";
import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [orderMixin],

  components: {
    Modal
  },

  props: {
    enabled: {
      type: Boolean,
      required: true
    },
    events: {
      type: Array,
      required: true
    }
  },

  methods: {
    event_name(event) {
      return event.split(".")[1].toLowerCase();
    }
  },

  computed: {
    orderEvents() {
      return this.events
        .map(event => {
          return {
            ...event,
            created_at: moment(event.created_at)
          };
        })
        .sort((a, b) => a.created_at.valueOf() - b.created_at.valueOf());
    }
  }
};
</script>

<template>
  <modal
    title="Eventos do pedido"
    size="md"
    v-if="enabled"
    @close="$emit('close')"
  >
    <template slot="body">
      <div>
        <ul>
          <li v-for="(event, index) in orderEvents" :key="index">
            {{ event.created_at.format("DD MMMM YYYY,HH:mm:ss") }} -
            {{ event_name(event.event_type) | getStatusName() }}
            <div
              id="description"
              v-if="event.description != null && event.description !== ''"
            >
              <strong class="pl-4">Descrição:</strong> {{ event.description }}
            </div>
          </li>
        </ul>
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        fechar
      </button>
    </template>
  </modal>
</template>

<style scoped>
#description {
  text-transform: lowercase;
}

li {
  list-style: none;
  text-transform: capitalize;
  font-weight: 300;
}

li:not(:last-child) {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/Events/Events.vue